import { getEventsForGroupId } from './api/events'
import { getKambiEventPricing } from './api/onDemandPricing'

export async function getHasSGMForEvent(eventId: number): Promise<boolean> {
  try {
    const pricingData = await getKambiEventPricing(eventId)

    return (pricingData.pricingList ?? []).some(
      pricing => (pricing.combinableOutcomeIds?.length ?? 0) > 0
    )
  } catch {
    return false
  }
}

export async function getHasSGMForGroup(groupId: number): Promise<boolean> {
  const eventsData = await getEventsForGroupId(groupId)

  const eventIds = (eventsData.events ?? []).map(event => event.id)

  if (eventIds.length === 0) {
    return false
  }

  for (const eventId of eventIds) {
    const hasSGMForEvent = await getHasSGMForEvent(eventId)

    if (hasSGMForEvent) {
      return true
    }
  }

  return false
}
